export const PANEL_STYLING_PROPERTIES = {
  headerStyle: 'text-align: center;',
  panelStyle: '',
  singleItemStyle: '',
  singleSkeletonStyle: '',
  productTitleStyle: '',
  productHeaderStyle: '',
  seeMoreLinkStyle: 'width: 100%; font-size: 1.4rem; text-align: center;',
  globalCss: '',
  rootDynamicClasses: [],
  backgroundColor: '#efefef',
  filterSelectVariables: '',
  headerContainerStyle: '',
  footerContainerStyle: '',
  rootCssVariables: '',
  arrayRendererStyle: '',
};
